import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../Containers/Config/index.js';
import apiCall from '../../apiCall.js';
import { GET_DASHBOARD_CONFIGURATION, GET_DASHBOARD_CONFIGURATION_ERROR, GET_DASHBOARD_CONFIGURATION_SUCCESS } from '../../../actions.js';

function* getDashboardConfiguration({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/dashboard-configurations`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_DASHBOARD_CONFIGURATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_DASHBOARD_CONFIGURATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_CONFIGURATION_ERROR, payload: error });
  }
}

export function* watchGetDashboardConfiguration() {
  yield takeEvery(GET_DASHBOARD_CONFIGURATION, getDashboardConfiguration);
}

function* getDashboardConfigurationSaga() {
  yield all([fork(watchGetDashboardConfiguration)]);
}

export default getDashboardConfigurationSaga;
